module.exports = __webpack_public_path__ + "img/file-img-zip.d023f861.jpg";